/* B1 · Estilo Titanturk: contador, carrusel, pestañas, videos */
(function () {
  if (window.__b1tt) return; window.__b1tt = true;
  function countdown(el) {
    if (el.__tt) return; el.__tt = true;
    var mins = parseInt(el.getAttribute('data-min') || '5', 10), key = 'tt-cd-end', end;
    try { end = parseInt(sessionStorage.getItem(key) || '0', 10); } catch (e) { end = 0; }
    if (!end || end < Date.now()) { end = Date.now() + mins * 60000; try { sessionStorage.setItem(key, end); } catch (e) {} }
    function tick() {
      var s = Math.max(0, Math.round((end - Date.now()) / 1000));
      if (s === 0) { end = Date.now() + mins * 60000; try { sessionStorage.setItem(key, end); } catch (e) {} s = mins * 60; }
      el.textContent = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
    }
    tick(); setInterval(tick, 1000);
  }
  function carousel(root) {
    if (root.__tt) return; root.__tt = true;
    var track = root.querySelector('[data-tt-track]'), slides = track ? track.children : [];
    var dots = root.querySelectorAll('[data-tt-dots] i'), thumbs = root.parentNode.querySelectorAll('[data-tt-thumb]');
    if (!track || slides.length < 2) return;
    function idx() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i) { i = (i + slides.length) % slides.length; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
    function mark() { var i = idx(); dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); }); thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); }); }
    track.addEventListener('scroll', function () { clearTimeout(track.__t); track.__t = setTimeout(mark, 60); });
    var p = root.querySelector('[data-tt-prev]'), n = root.querySelector('[data-tt-next]');
    if (p) p.addEventListener('click', function () { go(idx() - 1); });
    if (n) n.addEventListener('click', function () { go(idx() + 1); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    mark();
  }
  function tabs(root) {
    if (root.__tt) return; root.__tt = true;
    var btns = root.querySelectorAll('[data-tt-tab]'), pans = root.querySelectorAll('[data-tt-pan]');
    btns.forEach(function (b, k) {
      b.addEventListener('click', function () {
        btns.forEach(function (x, j) { x.classList.toggle('is-on', j === k); x.setAttribute('aria-selected', j === k); });
        pans.forEach(function (x, j) { x.hidden = j !== k; });
      });
    });
  }
  function video(w) {
    var v = w.tagName === 'VIDEO' ? w : w.querySelector('video');
    if (!v || v.__tt) return; v.__tt = true;
    v.addEventListener('click', function () { v.muted = !v.muted; if (v.paused) v.play(); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { if (e[0].isIntersecting) v.play().catch(function () {}); else v.pause(); }, { threshold: .5 }).observe(v);
  }
  function openDlg(d) { if (!d || d.open) return; if (d.showModal) d.showModal(); else d.setAttribute('open', ''); }
  function closeDlg(d) { if (d.close) d.close(); else d.removeAttribute('open'); }
  function dialogs() {
    document.querySelectorAll('dialog.tt-dlg').forEach(function (d) {
      if (d.__ttDlg) return; d.__ttDlg = true;
      // Fuera de <main>: el tema oculta <main> en computador y el pop-up no se vería
      if (d.parentNode !== document.body) document.body.appendChild(d);
      d.querySelectorAll('[data-tt-close]').forEach(function (b) { b.addEventListener('click', function () { closeDlg(d); }); });
      d.addEventListener('click', function (e) { if (e.target === d) closeDlg(d); });
    });
    document.querySelectorAll('[data-tt-open-reviews]').forEach(function (b) {
      if (b.__tt) return; b.__tt = true;
      b.addEventListener('click', function () {
        var d = document.querySelector('[data-tt-reviews-dlg]');
        if (d) openDlg(d); else { var r = document.getElementById('tt-reviews'); if (r) r.scrollIntoView({ behavior: 'smooth' }); }
      });
    });
  }
  function more(btn) {
    if (btn.__tt) return; btn.__tt = true;
    var wrap = btn.previousElementSibling, step = parseInt(wrap.getAttribute('data-step') || '3', 10);
    var items = wrap.querySelectorAll('.tt-rv');
    items.forEach(function (it, k) { if (k >= step) it.hidden = true; });
    btn.addEventListener('click', function () {
      var h = wrap.querySelectorAll('.tt-rv[hidden]');
      for (var i = 0; i < step && i < h.length; i++) h[i].hidden = false;
      if (!wrap.querySelector('.tt-rv[hidden]')) btn.remove();
    });
  }
  function offer(d) {
    if (d.__ttOffer) return; d.__ttOffer = true;
    var key = 'tt-offer-seen', idle = parseInt(d.getAttribute('data-idle') || '30', 10) * 1000, t;
    function seen() { try { return sessionStorage.getItem(key) === '1'; } catch (e) { return false; } }
    function show() {
      if (seen() || document.querySelector('dialog.tt-dlg[open]')) { reset(); return; }
      try { sessionStorage.setItem(key, '1'); } catch (e) {}
      openDlg(d); stop();
    }
    function reset() { clearTimeout(t); if (!seen()) t = setTimeout(show, idle); }
    var evs = ['scroll', 'touchstart', 'mousemove', 'keydown', 'click'];
    function stop() { clearTimeout(t); evs.forEach(function (e) { window.removeEventListener(e, reset); }); }
    // Vista previa: agrega ?tt_offer=1 a la URL para verlo al instante (aunque esté apagado)
    if (/[?&]tt_offer=1/.test(location.search)) { setTimeout(function () { openDlg(d); }, 600); return; }
    if (d.getAttribute('data-live') !== 'true') return;
    if (seen()) return;
    evs.forEach(function (e) { window.addEventListener(e, reset, { passive: true }); });
    reset();
    if (d.getAttribute('data-exit') === 'true') document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) show(); });
  }
  function stats(box) {
    if (box.__ttStats) return; box.__ttStats = true;
    var items = box.querySelectorAll('.tt-stat');
    items.forEach(function (it) {
      var b = it.querySelector('b'); if (!b) return;
      var m = b.textContent.match(/^(\D*)(\d+(?:[.,]\d+)?)(.*)$/);
      if (!m) return;
      var n = parseFloat(m[2].replace(',', '.'));
      if (/%/.test(m[3]) && n <= 100) it.style.setProperty('--p', n + '%'); else it.style.setProperty('--p', '100%');
      it.__tt = { pre: m[1], n: n, post: m[3], dec: (m[2].split(/[.,]/)[1] || '').length, el: b };
      b.textContent = m[1] + '0' + m[3];
    });
    function run() {
      items.forEach(function (it, k) {
        setTimeout(function () {
          it.classList.add('is-in');
          var d = it.__tt; if (!d) return;
          var t0 = null, dur = 1400;
          function step(ts) {
            if (!t0) t0 = ts;
            var p = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - p, 3);
            d.el.textContent = d.pre + (d.n * e).toFixed(d.dec) + d.post;
            if (p < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        }, k * 220);
      });
    }
    if (!('IntersectionObserver' in window)) { run(); return; }
    var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { io.disconnect(); run(); } }, { threshold: .3 });
    io.observe(box);
  }
  function buyTT(box) {
    if (box.__ttBuy) return; box.__ttBuy = true;
    var id = box.querySelector('input[name="id"]'), qty = box.querySelector('input[name="quantity"]');
    var sizes = box.querySelectorAll('[data-tt-size]'), packs = box.querySelectorAll('[data-tt-pack]');
    var link = box.querySelector('[data-b1c-checkout]'), sub = box.querySelector('.tt-cta--dark small');
    var baseSub = sub ? sub.textContent : '';
    sizes.forEach(function (b) {
      b.addEventListener('click', function () {
        sizes.forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-checked', x === b); });
        if (id) id.value = b.getAttribute('data-tt-size');
        if (link) link.setAttribute('data-variant', b.getAttribute('data-tt-size'));
      });
    });
    function pick(p) {
      packs.forEach(function (x) { x.classList.toggle('is-on', x === p); x.setAttribute('aria-checked', x === p); });
      if (qty) qty.value = p.getAttribute('data-qty') || '1';
      if (sub) sub.textContent = (p.querySelector('.tt-pack__m b') || {}).textContent + ' · ' + p.getAttribute('data-price') + (baseSub ? ' · ' + baseSub : '');
    }
    packs.forEach(function (p) {
      p.addEventListener('click', function () { pick(p); });
      p.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(p); } });
    });
    var pre = box.querySelector('[data-tt-pack].is-on') || packs[0];
    if (pre) pick(pre);
  }
  function dates() {
    document.querySelectorAll('[data-tt-date]').forEach(function (el) {
      if (el.__tt) return; el.__tt = true;
      var n = parseInt(el.getAttribute('data-tt-date') || '3', 10), d = new Date();
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
      el.textContent = d.toLocaleDateString('es-CO', { weekday: 'short', day: 'numeric', month: 'short' });
    });
  }
  function scrollers() {
    document.querySelectorAll('[data-tt-scroll]').forEach(function (a) {
      if (a.__tt) return; a.__tt = true;
      a.addEventListener('click', function (e) { var t = document.getElementById('b1-buy'); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); } });
    });
  }
  function timeline(tl) {
    if (tl.__tt) return; tl.__tt = true;
    var items = tl.querySelectorAll('li');
    function upd() {
      var r = tl.getBoundingClientRect(), mid = window.innerHeight * 0.6;
      var p = Math.max(0, Math.min(1, (mid - r.top) / Math.max(1, r.height)));
      tl.style.setProperty('--tl-p', p.toFixed(3));
      items.forEach(function (li) { if (li.getBoundingClientRect().top < mid) li.classList.add('is-in'); });
    }
    window.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
  }
  function init() {
    document.querySelectorAll('.tt-tl').forEach(timeline);
    document.querySelectorAll('[data-tt-buy]').forEach(buyTT); dates(); scrollers();
    dialogs();
    document.querySelectorAll('.tt-survey').forEach(stats);
    document.querySelectorAll('[data-tt-more]').forEach(more);
    document.querySelectorAll('[data-tt-offer]').forEach(offer);
    document.querySelectorAll('[data-tt-cd]').forEach(countdown);
    document.querySelectorAll('[data-tt-car]').forEach(carousel);
    document.querySelectorAll('[data-tt-tabs]').forEach(tabs);
    document.querySelectorAll('[data-tt-video]').forEach(video);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
